import {createClient} from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Default timeout for Supabase requests (20 seconds for slow devices like tablets)
const SUPABASE_TIMEOUT_MS = 20_000;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Supabase credentials not configured! Check your .env file.');
}

/**
 * Get Supabase's default storage key.
 * Supabase stores session as `sb-{project-ref}-auth-token`.
 */
export const getSupabaseStorageKey = (): string => {
    const projectRef = new URL(supabaseUrl).hostname.split('.')[0];
    return `sb-${projectRef}-auth-token`;
};

/**
 * Custom fetch wrapper with extended timeout for slow devices.
 */
const fetchWithTimeout: typeof fetch = (input, init) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), SUPABASE_TIMEOUT_MS);

    return fetch(input, {
        ...init,
        signal: controller.signal,
    }).finally(() => clearTimeout(timeoutId));
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: getSupabaseStorageKey(),
    },
    global: {
        fetch: fetchWithTimeout,
    },
});
